import { render } from "./OnboardRegisterModal.vue?vue&type=template&id=17908e09"
import script from "./OnboardRegisterModal.vue?vue&type=script&lang=js"
export * from "./OnboardRegisterModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__